import { Controller } from '@hotwired/stimulus';

/**
 * Shows the bishop name in a preview field when a diocese is selected.
 *
 *   data-controller="diocesis-obispo"
 *   data-diocesis-obispo-url-value="/api/diocesis/__ID__/obispo"
 *
 * Targets:
 *   data-diocesis-obispo-target="select"   (the diocese select)
 *   data-diocesis-obispo-target="preview"  (the element showing the bishop text)
 */
export default class extends Controller {

    static values = { url: String };
    static targets = ['select', 'preview'];

    declare readonly urlValue: string;
    declare readonly selectTarget: HTMLSelectElement;
    declare readonly previewTarget: HTMLElement;

    connect(): void {
        // Render the initial value if a diocese is already selected.
        if (this.selectTarget.value) {
            void this.fetchAndRender(this.selectTarget.value);
        }
    }

    onChange(): void {
        const id = this.selectTarget.value;
        if (!id) {
            this.previewTarget.textContent = '—';
            return;
        }
        void this.fetchAndRender(id);
    }

    private async fetchAndRender(id: string): Promise<void> {
        try {
            const url = this.urlValue.replace('__ID__', id);
            const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!res.ok) return;
            const data = await res.json() as { obispo: string | null };
            this.previewTarget.textContent = data.obispo ?? '—';
        } catch {
            this.previewTarget.textContent = '—';
        }
    }
}
